// dependencies
import * as React from "react";

import { cn } from "../../../lib/utils";

// components
import ComponentLoader from "../../atoms/ComponentLoader";
import { CyclingText, CyclingTextProps } from "../../atoms/LoadingIndicatorText";
import { Text } from "../../atoms/Text";

export type LogoLoaderProps = {
	/**
	 * Array of strings to cycle through for the text
	 */
	textArray: string[];
	/**
	 * Main text to display
	 */
	mainText: string;
	/**
	 * Duration in milliseconds between text changes
	 * @default 2000
	 */
	switchTimer?: number;
	/**
	 * Additional className for the container
	 */
	dangerouslySetClassName?: string;
} & Omit<CyclingTextProps, "textArray" | "switchTimer" | "dangerouslySetClassName">;

/**
 * LogoLoader component that combines ComponentLoader and CyclingText
 * for a complete loading experience with animated icons and cycling text
 */
export const LogoLoader = React.forwardRef<HTMLDivElement, LogoLoaderProps>(function LogoLoader(props, ref) {
	const { textArray, switchTimer = 2000, dangerouslySetClassName, mainText, ...textProps } = props;

	return (
		<div
			ref={ref}
			className={cn("flex min-h-full w-full flex-col items-center justify-center gap-4", dangerouslySetClassName)}
		>
			<ComponentLoader />
			<div className="flex flex-col items-center">
				<Text size="paragraph-3" weight="semi-bold">
					{mainText}
				</Text>
				<CyclingText {...textProps} textArray={textArray} switchTimer={switchTimer} />
			</div>
		</div>
	);
});

LogoLoader.displayName = "LogoLoader";
